const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
export const utf8Encode = (value) => {
    const bytes = [];
    for (const char of value) {
        let codePoint = char.codePointAt(0) ?? 0;
        if (codePoint < 0x80) {
            bytes.push(codePoint);
        }
        else if (codePoint < 0x800) {
            bytes.push(0xc0 | (codePoint >> 6), 0x80 | (codePoint & 0x3f));
        }
        else if (codePoint < 0x10000) {
            if (codePoint >= 0xd800 && codePoint <= 0xdfff) {
                codePoint = 0xfffd;
            }
            bytes.push(0xe0 | (codePoint >> 12), 0x80 | ((codePoint >> 6) & 0x3f), 0x80 | (codePoint & 0x3f));
        }
        else {
            bytes.push(0xf0 | (codePoint >> 18), 0x80 | ((codePoint >> 12) & 0x3f), 0x80 | ((codePoint >> 6) & 0x3f), 0x80 | (codePoint & 0x3f));
        }
    }
    return Uint8Array.from(bytes);
};
export const utf8Decode = (bytes) => {
    let result = '';
    let i = 0;
    while (i < bytes.length) {
        const byte = bytes[i];
        let codePoint;
        let length;
        if (byte < 0x80) {
            codePoint = byte;
            length = 1;
        }
        else if ((byte & 0xe0) === 0xc0) {
            codePoint = byte & 0x1f;
            length = 2;
        }
        else if ((byte & 0xf0) === 0xe0) {
            codePoint = byte & 0x0f;
            length = 3;
        }
        else if ((byte & 0xf8) === 0xf0) {
            codePoint = byte & 0x07;
            length = 4;
        }
        else {
            throw new Error('Invalid UTF-8');
        }
        if (i + length > bytes.length) {
            throw new Error('Invalid UTF-8');
        }
        for (let j = 1; j < length; j++) {
            const next = bytes[i + j];
            if ((next & 0xc0) !== 0x80) {
                throw new Error('Invalid UTF-8');
            }
            codePoint = (codePoint << 6) | (next & 0x3f);
        }
        result += String.fromCodePoint(codePoint);
        i += length;
    }
    return result;
};
export const base64EncodeUnpadded = (bytes) => {
    let output = '';
    for (let i = 0; i < bytes.length; i += 3) {
        const b0 = bytes[i];
        const b1 = i + 1 < bytes.length ? bytes[i + 1] : 0;
        const b2 = i + 2 < bytes.length ? bytes[i + 2] : 0;
        const triple = (b0 << 16) | (b1 << 8) | b2;
        output += ALPHABET[(triple >> 18) & 0x3f];
        output += ALPHABET[(triple >> 12) & 0x3f];
        if (i + 1 < bytes.length) {
            output += ALPHABET[(triple >> 6) & 0x3f];
        }
        if (i + 2 < bytes.length) {
            output += ALPHABET[triple & 0x3f];
        }
    }
    return output;
};
export const canonicalJsonStringArray = (values) => JSON.stringify(values);
